import axios from 'axios';

export const get = () => axios.get('/api/pipelines');

export const create = (payload, { is_shared = false } = {}) => axios.put(
  `/api/pipelines?is_shared=${is_shared}`,
  payload,
);

export const update = (id, payload, { is_shared = false } = {}) => axios.post(
  `/api/pipelines/${id}?is_shared=${is_shared}`,
  payload,
);

export const remove = id => axios.delete(`/api/pipelines/${id}`);
